/**
 * NPO Finance — the Canada NPO module theme. Since 2026-07 it uses the Paper
 * Finance design system (templates/npo/npo-finance-preview.html) — that preview
 * is the NPO module reference. A separate id is kept: /canada-npo/finance routes
 * force this theme regardless of the user's selection.
 */
import { Theme } from "@mui/material/styles";
import type { ThemeConfig } from "./types";
import { createPaperFinanceTheme } from "./paperFinance";

export const createNpoFinanceTheme = (): Theme => createPaperFinanceTheme();

export const npoFinanceThemeConfig: ThemeConfig = {
  id: "npo-finance",
  name: "NPO Finance",
  description:
    "Paper Finance design system applied to the Canada NPO module (matches the module preview)",
  createTheme: createNpoFinanceTheme,
};
